import {
  STORE_AUTHENTICATION,
  CLEAR_AUTHENTICATION,
  LOGOUT_GOV_BR,
} from "../constants/actionCreators";

const initialState = {};

export default (store, action) => {
  if (action.type === STORE_AUTHENTICATION) {
    return action.user;
  }
  if (action.type === CLEAR_AUTHENTICATION) {
    store = {};
  }
  if (action.type === LOGOUT_GOV_BR) {
   store = {}
  }
  return store || initialState;
};
